import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import useScrollLockOnMount from "../Helpers/utils";

const Information = ({ type, onClose }) => {
  const [details, setDetails] = useState(""); // `details` is now a string
  const [updatedAt, setUpdatedAt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useScrollLockOnMount();

  useEffect(() => {
    const fetchMoreInfo = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch(`/php/fetch_information.php?type=${type}`);
        const data = await response.json();

        if (response.ok) {
          setDetails(data.details || "No information available for this section.");
          setUpdatedAt(data.updated_at || null);
        } else {
          setError(data.message || "Something went wrong");
        }
      } catch (err) {
        setError("Error fetching data");
      } finally {
        setLoading(false);
      }
    };

    if (type) fetchMoreInfo();
  }, [type]);

  const isMobile =
    /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return date.toLocaleString(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="more-info-modal" style={{ display: "block" }}>
      <div id="more-info" style={{ display: "block" }}>
        <header
          style={{
            backgroundColor: "lightgreen",
            padding: "10px",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            position: "sticky",
            top: 0,
            zIndex: 1,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                fontSize: "20px",
                marginLeft: "20px",
                color: "white",
                textAlign: "center",
                width: "100%",
              }}
            >
              Information
            </div>
            <span
              style={{
                fontSize: "33px",
                cursor: "pointer",
                color: "white",
                marginTop: isMobile ? "-5px" : "1px",
              }}
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
            >
              ×
            </span>
          </div>
        </header>

        <div
          style={{
            fontSize: "16px",
            textAlign: "center",
            color: "#333",
            margin: "7px",
            whiteSpace: "pre-wrap",
          }}
        >
          {loading ? (
            <p>Loading...</p>
          ) : error ? (
            <p style={{ color: "red" }}>Error: {error}</p>
          ) : (
            <>
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(details),
                }}
                style={{
                  textAlign: "left",
                  lineHeight: 1.2,
                }}
              />
              {updatedAt && (
                <p
                  style={{
                    marginTop: "15px",
                    fontSize: "12px",
                    color: "#666",
                    textAlign: "right",
                    fontStyle: "italic",
                  }}
                >
                  Updated at: {formatDate(updatedAt)}
                </p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Information;
